module.exports = __webpack_public_path__ + "static/media/29BDOS5.51ddcb98.jpg";